import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import { Stop } from "@material-ui/icons";
import DataTable from "../../../../components/DataTable/DataTable";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { convertToDateFormat } from '../../../../helpers/helper';
import { inProgressListState, alertState, personalizationState } from "../../../../recoil-store/recoil-state";
import AutomService from "../../../../services/AutomService/AutomService";

function ProgressMonitor(props) {
    const { t } = useTranslation();
    const inProgressList = useRecoilValue(inProgressListState);
    const personalization = useRecoilValue(personalizationState);
    const setAlert = useSetRecoilState(alertState);

    const {
        loading,
        setSearchKeyData,
        setSearchData,
        searchData,
        setCustomColumn,
        customColumn,
        fetchData
    } = props;

    useEffect(() => {
        setSearchData(inProgressList);
    }, [inProgressList, setSearchData]);

    const handleStop = async (e) => {
        const res = await AutomService.cancelAutom({ operationId: e.id, mate_id: e.mate_id });
        if (res) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: "MESSAGES.AUTOMS." + res.message,
                severity: res.status ? 'success' : 'error'
            }))
            if (res.status) {
                fetchData('["IN-PROGRESS"]');
            }
        }
    }

    useEffect(() => {
        const column = [
            {
                id: -1,
                name: "",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                },
            },
            {
                id: 0,
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return <span>{dataIndex + 1}.</span>;
                        }
                    },
                },
            },
            {
                id: 1,
                name: "name",
                label: t("MESSAGES.MONITORING.AUTOM-NAME"),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (
                                <div>
                                    {
                                        <Link
                                            data-test="credential-link"
                                            to={`/dashboard/monitoring/${searchData[dataIndex].id}`}
                                        >
                                            {searchData[dataIndex]?.name}
                                        </Link>
                                    }
                                </div>
                            );
                        }
                    },
                },
            },
            {
                id: 2,
                name: "qpool_name",
                label: t("MESSAGES.MONITORING.QUEUE-POOL-NAME"),
                options: { filter: true, sort: true },
            },
            {
                id: 3,
                name: "run_by",
                label: t("MESSAGES.MONITORING.RUN-BY"),
                options: { filter: true, sort: false },
            },
            {
                id: 4,
                name: "mate_name",
                label: t("MESSAGES.MONITORING.MATE-NAME"),
                options: { filter: true, sort: true },
            },
            {
                id: 5,
                name: "type",
                label: t("MESSAGES.MONITORING.TYPE"),
                options: { filter: true, sort: true },
            },
            {
                id: 6,
                name: "created_at",
                label: t("MESSAGES.MONITORING.STARTED-AT"),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return convertToDateFormat(searchData[dataIndex]?.created_at, personalization.date_format);
                        }
                    },
                },
            },
            {
                id: 7,
                name: "updated_at",
                label: t("MESSAGES.MONITORING.UPDATED-AT"),
                options: { filter: true, sort: true, display: false },
            }, {
                id: 8,
                name: "actions",
                label: t("CONTENT.AUTOMS-LIST.ACTIONS"),
                options: {
                    filter: true, sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (<>
                                <IconButton size="small" onClick={() => handleStop(searchData[dataIndex])}>
                                    <Stop style={{ color: '#D75E5E' }} />
                                </IconButton>
                            </>);
                        }
                    }
                }
            }
        ];
        setCustomColumn(column);
        setSearchKeyData(["name", "qpool_name", "run_by", "mate_name", "type", "created_at", "updated_at"]);
    }, [searchData, t, setCustomColumn, setSearchKeyData]);

    return (
        <div>
            <DataTable
                data={searchData}
                customColumns={customColumn}
                selectableRows={"none"}
                title={t("MESSAGES.MONITORING.AUTOM-MONITORING")}
                loading={loading}
            />
        </div>
    );
}

export default ProgressMonitor;
